import { render, staticRenderFns } from "./NewSubjectAddSubject.vue?vue&type=template&id=06c4ff35&"
import script from "./NewSubjectAddSubject.vue?vue&type=script&lang=js&"
export * from "./NewSubjectAddSubject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports